import { Post2 } from "./classroomApi";

export type SubmitFeedbackRequest = {
	message: string;
	applianceId: string;
	teacherUsername: string;
	classroomName: string;
	classroomStableId: string;
	classroomId: string;
};

export const submitFeedback = async (request: SubmitFeedbackRequest): Promise<undefined> => {
	return await Post2(`v1/teacher-feedback`, request);
};
